import axios from "axios";
import API from "../_helpers/endpointService";

export const getprojectdisprodocinfo = (data, id) => {
    let apiUrl = API.DISMANTLING_PROGRESS + '?projectId=' + id + '&Description=' + data.Description + '&DateTimeFrom=' + data.DateTimeFrom + '&DateTimeTo=' + data.DateTimeTo + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
    return (dispatch) => {
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    dispatch({ type: "DISPRO_DOCS", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
};

export const gethistorylogdisproinfo = (id) => {
    let apiUrl = API.HISTORY_LOG + id + '?name=DismantlingProgress'
    return (dispatch) => {
      dispatch({ type: "SHOW_LOADER", data: true })
      axios({
        method: "GET",
        url: apiUrl,
        // data: data,
      })
        .then((response) => {
          dispatch({ type: "SHOW_LOADER", data: false })
          if (response?.status === 200) {
            dispatch({ type: "HISTORY_LOG", data: response.data });
          } else {
          }
        })
        .catch((error) => {
          dispatch({ type: "SHOW_LOADER", data: false })
          if (error?.response?.status === 401) {
            // logOut();
          }
        });
    };
  };

  export const filedeletedispro = (id, name) => {
    let apiUrl = API.DISMANTLING_PROGRESS + '/Drawings/id?id=' + id + '&filename=' + name;
    return (dispatch) => {
      axios({
        method: "DELETE",
        url: apiUrl,
        // data: data,
        // headers : {
        //   'content-type': 'application/json'
        // }
      })
        .then((response) => {
          if (response?.status === 200) {
          } else {
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            // logOut();
          }
        });
    };
  };